<template>
  <div>
    <span v-if="!loading && templateList.length == 0" class="text-danger"
      >The language id {{ model.language_id }} has no template
      configurated</span
    >
    <div class="card mt-3" v-if="!onlyresult">
      <LoadingSpinner v-if="loading" />
      <div class="body p-4 email-account" v-if="!loading">
        <div class="mt-3">
          <div class="row">
            <div class="col-md-4">
              <table class="table table-striped">
                <thead class="thead-dark">
                  <tr>
                    <th width="50px">
                      <vue-form-generator
                        :schema="schemaLanguage"
                        :model="model"
                        :options="formOptions"
                      ></vue-form-generator>
                    </th>
                    <th scope="col">
                      {{ $t("lang.label.template") }} /
                      <span
                        v-if="
                          campaignStepTemplateTypeId == 1 &&
                          campaignStepTemplatePartId == 1
                        "
                        >{{ $t("lang.label.step") }} {{ step }}</span
                      >
                      <span v-else-if="campaignStepTemplatePartId == 1">{{
                        $t("lang.label.message")
                      }}</span>
                      <span v-else> {{ $t("lang.label.subject") }} </span>
                      <Tooltip
                        text="New Template"
                        class="float-right"
                        width="50px"
                      >
                        <button
                          class="btn btn-primary"
                          @click="newTemplate"
                          type="submit"
                        >
                          <i class="icon-plus1"></i>
                        </button>
                      </Tooltip>
                      <span class="float-right mr-4" v-if="totalPages > 0">
                        <Tooltip text="Current page" width="50px">
                          <input
                            type="number"
                            v-model="model.currentPage"
                            min="1"
                            :max="totalPages"
                            @change="changePage()"
                            style="width: 50px"
                          />
                        </Tooltip>
                        /
                        <Tooltip text="Total pages" width="50px">
                          {{ totalPages }}
                        </Tooltip>
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody v-if="templateList">
                  <tr v-for="(template, key) in templateList" :key="key">
                    <td
                      @click="getTemplate(template.id)"
                      :class="{
                        'bg-primary text-white': isRowSelected(template),
                      }"
                      class="cursor-pointer"
                    >
                      <i
                        class="icon-clock-o mr-3"
                        v-if="template.campaign_step_template_status_id == 1"
                      ></i>
                      <i class="icon-check1 mr-3" v-else></i>
                    </td>
                    <td
                      @click="getTemplate(template.id)"
                      :class="{
                        'bg-primary text-white': isRowSelected(template),
                      }"
                      class="cursor-pointer"
                    >
                      <div style="max-height: 45px; overflow: hidden">
                        <span v-html="template.message"></span>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="no-results-row">
                    <td>
                      <span class="font-weight-bold ft-1-5 text-center"
                        >There are no data</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-4">
              <LoadingSpinner v-if="loadingCurrent" />
              <div v-else>
                <div
                  class="field-ckeditor-wrappar"
                  v-if="campaignStepTemplatePartId == 2"
                >
                  <ValidationProvider
                    ref="editorMessageV"
                    :rules="{
                      required: true,
                      'token-validation': [availableTokensSelect],
                      'length-plain-text': [{ max: 160 }],
                    }"
                  >
                    <div slot-scope="{ errors }">
                      <div
                        class="form-group valid featured required col-sm-12 field-input field-ckeditor"
                        :class="errors.length > 0 ? 'error' : ''"
                      >
                        <label> {{ $t("lang.label.subject") }}</label>

                        <ckeditor
                          :editor="editorInitial"
                          v-model="editorMessage"
                          :config="editorConfigMinimum"
                        ></ckeditor>

                        <div class="errors help-block">
                          <span>{{ errors[0] }}</span>
                        </div>
                      </div>
                    </div>
                  </ValidationProvider>
                </div>

                <div
                  class="field-ckeditor-wrappar"
                  v-if="campaignStepTemplatePartId == 1"
                >
                  <ValidationProvider
                    ref="editorMessageV"
                    :rules="{
                      required: true,
                      'token-validation': [availableTokensSelect],
                    }"
                  >
                    <div slot-scope="{ errors }">
                      <div
                        class="form-group valid featured required col-sm-12 field-input field-ckeditor"
                        :class="errors.length > 0 ? 'error' : ''"
                      >
                        <label> {{ $t("lang.label.message") }}</label>

                        <ckeditor
                          :editor="editorInitial"
                          v-model="editorMessage"
                          :config="editorConfig"
                        ></ckeditor>

                        <div class="errors help-block">
                          <span>{{ errors[0] }}</span>
                        </div>
                      </div>
                    </div>
                  </ValidationProvider>
                </div>

                <div class="px-3 py-2">
                  <vue-form-generator
                    ref="stepForm"
                    :schema="schemaStatus"
                    :model="modelStep"
                    :options="formOptions"
                  ></vue-form-generator>

                  <ValidationProvider
                    ref="tagsV"
                    :rules="{
                      required: false,
                    }"
                    class="d-block"
                  >
                    <div
                      slot-scope="{ errors }"
                      v-show="
                        modelStep.parent_id == undefined &&
                        campaignStepTemplateTypeId == '1'
                      "
                    >
                      <div
                        class="form-group featured"
                        :class="errors.length > 0 ? 'error' : ''"
                      >
                        <label>
                          <span>Tags</span>
                        </label>
                        <multiselect
                          v-model="tags"
                          tag-placeholder="Add this as new tag"
                          v-bind:placeholder="$t('lang.label.searchoraddatag')"
                          label="name"
                          track-by="id"
                          :options="tag_2"
                          :multiple="true"
                          :taggable="true"
                          :searchable="true"
                          :showLabels="false"
                          openDirection="below"
                          class="small"
                          @input="formatTags($event)"
                        >
                        </multiselect>

                        <div class="errors help-block">
                          <span>{{ errors[0] }}</span>
                        </div>
                      </div>
                    </div>
                  </ValidationProvider>
                </div>

                <!-- SAVE  -->
                <button
                  class="float-right btn btn-primary mt-3"
                  @click="saveStep"
                  type="submit"
                >
                  <i class="icon-plus1"></i> {{ $t("lang.button.save") }}
                </button>
                <!-- DELETE  -->
                <button
                  v-if="
                    modelStep.id !== undefined &&
                    modelStep.parent_id !== undefined
                  "
                  class="float-right btn btn-danger mt-3 mr-2"
                  @click="deleteStep"
                  type="submit"
                >
                  <i class="icon-remove"></i> {{ $t("lang.general.delete") }}
                </button>
              </div>
            </div>
            <div class="col-md-4 template-msg">
              <div class="py-2 px-2 my-4 bg-lg">
                <div class="w-100 px-2 py-2" style="height: inherit">
                  <span
                    v-if="model"
                    v-html="
                      $sanitize(
                        formatTokensAgency(
                          convertNLtoBR(this.modelStep.message),
                          emailDataToken[0]
                        ),
                        sanitizeAllowedTags
                      )
                    "
                  ></span>
                </div>
              </div>
              <div class="d-flex justify-content-center align-items-center">
                <div class="text-center">
                  <small>{{
                    $t("lang.label.testwithdifferentprospects")
                  }}</small>
                  <div class="my-2">
                    <button
                      class="ml-3 btn btn-primary themed-button btn-sm text-right"
                      @click="changeBusinessContactSelected(-1)"
                    >
                      <i class="icon-navigate_before"></i>
                    </button>
                    <span class="mx-2 minw-150">{{
                      this.testBusinessContact[
                        this.testBusinessContactSelected
                      ]["[prospect_company_name]"]
                    }}</span>
                    <button
                      class="ml-3 btn btn-primary themed-button btn-sm text-right"
                      @click="changeBusinessContactSelected(1)"
                    >
                      <i class="icon-navigate_next"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="onlyresult">
      <div class="row mb-4" v-if="!simplify">
        <div class="col-6">
          <img
            width="20px"
            class="rounded-circle d-inline"
            src="data:image/png;base64,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"
            alt=""
          />
          <small class="dataSend ml-1">
            <strong class="emisor">{{ currentUser.name }}</strong>
            <span class="text-secondary ml-1"> <{{ currentUser.email }}> </span>

            <p class="text-secondary ml-4">to me</p>
          </small>
        </div>
        <div class="col-6">
          <small class="float-right w50">
            <small class="text-secondary">{{ new Date() }}</small>
          </small>
        </div>
      </div>

      <span
        v-if="loading"
        class="loadingres mr-2 ml-2 spinner-border loading-spinner"
      ></span>
      <span
        :class="
          simplify && campaignStepTemplatePartId == '1' ? 'scroll-class' : ''
        "
        v-if="model && !loading"
        v-html="
          formatTokensAgency(
            convertNLtoBR(this.modelStep.message),
            emailDataToken[0]
          )
        "
      ></span>

      <div class="row mb-4" v-if="!simplify">
        <div class="col-6">
          <div class="dataSend ml-1 w100 mt-3 mb-1">
            <strong class="emisor">{{ currentUser.name }}</strong>
          </div>
          <img
            width="50px"
            class="rounded-circle d-inline"
            src="data:image/png;base64,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"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { mapState, mapActions } from "vuex";
import {
  statusPointMixin,
  formattersMixin,
  campaignUtilsMixin,
} from "@/_mixins/";
import { adminService, tagsService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import VueFormGenerator from "vue-form-generator";
import "vue-form-generator/dist/vfg.css";
import Tutorial from "@/components/Tutorial.vue";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Tooltip from "@/components/Common/Tooltip.vue";
import Multiselect from "vue-multiselect";

export default {
  props: {
    emailTo: String,
    simplify: Boolean,
    currentUser: {},
    defaultTokens: {
      type: Boolean,
      default: false,
    },
    step: {
      type: Number,
      required: true,
    },
    onlyresult: {
      type: Boolean,
      default: false,
    },
    templateId: {
      type: Number,
    },
    lang: {
      default: 1,
    },
    statusTemplate: {
      type: Number,
    },
    availableTokens: {
      type: Array,
      default: [],
    },
    cantPerPage: {
      type: Number,
      default: 7,
    },
    isPreviewEmail: {
      type: Boolean,
      default: false,
    },
    tag_id: {
      type: [Number, String],
      default: undefined,
    },
    campaignTemplate: {
      type: Boolean,
      default: false,
    },
    availableTokensSelect: Array,
    campaignStepTemplateTypeId: Number,
    campaignStepTemplatePartId: Number,
    enabled: String,
  },
  data() {
    var self = this;
    return {
      sanitizeAllowedTags: {
        allowedTags: [
          "p",
          "a",
          "i",
          "s",
          "u",
          "br",
          "h1",
          "h2",
          "h3",
          "span",
          "strong",
          "img",
        ], // Permitir las etiquetas div y span
        allowedAttributes: {
          p: ["style"],
          a: ["style"],
          span: ["style"], // Permitir el atributo class en elementos span
          img: ["src", "title", "style"],
        },
        allowedSchemes: ["data", "https"],
      },
      tags: [],
      totalItems: 0,
      loading: true,
      loadingCurrent: false,
      selectFirst: false,
      result_invitation: "",
      templateList: [],
      model: { language_id: 1 },
      modelStep: {},
      request: false,
      dataUser: {},
      editorInitial: ClassicEditor,
      editorMessage: "",
      editorConfig: {
        isReadOnly: false,
        readOnly: false,
        fontSize: {
          options: ["default", 14, 16, 18, 20, 22, 24],
        },
        // fontColor: {
        //   colorPicker: {
        //       format: 'rgb'
        //     }
        // },
        toolbar: {
          items: [
            "undo",
            "redo",
            "|",
            "heading",
            "|",
            "fontSize",
            "fontColor",
            "fontBackgroundColor",
            "-",
            "bold",
            "italic",
            "strikethrough",
            "underline",
            "|",
            "alignment",
            "|",
            "link",
            // "|",
            "autoplaceholder",
          ],
          shouldNotGroupWhenFull: true,
        },
        // indentBlock: {
        //     offset: 1,
        //     unit: 'em'
        // },
        autoplaceholder: {
          tokenList: this.availableTokensSelect,
          label: this.$t("lang.button.variables"),
          textos: {
            label: this.$t("lang.button.setadefaultvalue"),
            save: this.$t("lang.button.save"),
            cancel: this.$t("lang.button.cancel"),
          },
        },
      },
      editorConfigMinimum: {
        /*plugins: [ Essentials, Heading, Bold, Italic, Link, AutoPlaceholder ],*/
        toolbar: ["autoplaceholder"],
        autoplaceholder: {
          tokenList: this.availableTokensSelect,
          label: this.$t("lang.button.variables"),
          textos: {
            label: this.$t("lang.button.setadefaultvalue"),
            save: this.$t("lang.button.save"),
            cancel: this.$t("lang.button.cancel"),
          },
        },
      },
      schemaStatus: {
        fields: [
          {
            type: "select",
            label: this.$t("lang.label.status"),
            model: "campaign_step_template_status_id",
            featured: true,
            required: true,
            values: function () {
              return [
                { id: "1", name: "Draft" },
                { id: "2", name: "Published" },
              ];
            },
            default: "1",
          },
          {
            type: "select",
            label: this.$t("lang.label.language"),
            model: "language_id",
            featured: true,
            required: true,
            disabled: true,
            values: () => {
              return self.langs;
            },
            default: "2",
          },
          // {
          //   type: "input",
          //   inputType: "hidden",
          //   model: "parent_id",
          //   featured: true,
          //   required: true,
          // },
          // {
          //   type: "input",
          //   inputType: "hidden",
          //   model: "id",
          //   featured: true,
          //   required: true,
          // },
        ],
      },
      schemaLanguage: {
        fields: [
          {
            type: "select",
            label: this.$t("lang.label.language"),
            model: "language_id",
            featured: true,
            required: true,
            // disabled: function (model) {
            //   return model.id === undefined;
            // },
            values: () => {
              return self.langs;
            },
          },
        ],
      },
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: true,
      },
    };
  },

  mixins: [statusPointMixin, formattersMixin, campaignUtilsMixin],

  components: {
    LoadingSpinner,
    "vue-form-generator": VueFormGenerator.component,
    Tutorial,
    ckeditor: CKEditor.component,
    Tooltip,
    Multiselect,
  },

  watch: {
    modelStep: function () {
      if (
        this.modelStep !== undefined &&
        this.modelStep.message !== undefined
      ) {
        setTimeout(() => {
          this.editorMessage = this.modelStep.message;
        }, 5);
      }
    },
    templateList: function (currentValue, beforeValue) {
      if (
        (this.selectFirst || Object.entries(beforeValue).length == 0) &&
        Object.entries(currentValue).length > 0
      ) {
        this.getTemplate(currentValue[0].id);
        this.selectFirst = false;
      } else if (Object.entries(currentValue).length == 0) {
        this.loadingCurrent = false;
      }
    },
    editorMessage: function () {
      if (this.editorMessage !== undefined) {
        this.modelStep.message = this.editorMessage;
      }
    },
    "modelStep.language_id": function (currentValue, beforeValue) {
      if (currentValue === undefined || beforeValue === undefined) {
        return;
      }
      if (currentValue == 1 && this.model.parent_id !== undefined) {
        this.getTemplate(this.modelStep.parent_id);
      } else {
        // template for new language
        this.modelStep.parent_id =
          this.modelStep.parent_id !== undefined &&
          this.modelStep.parent_id !== null
            ? this.modelStep.parent_id
            : this.modelStep.id;

        this.modelStep.id = null;
        this.getTemplate(null, true);
      }
    },
    "model.language_id": function (currentValue, beforeValue) {
      this.selectFirst = true;
      this.getData();
    },
  },

  computed: {
    ...mapState({
      langs: (state) => state.optionsList.all["languages"].data,
      emailDataToken: (state) => state.onboarding.emailDataToken,
      tag_2: (state) => state.optionsList.all["tag_2"].data,
    }),
    totalPages() {
      return Math.ceil(this.totalItems / this.cantPerPage);
    },
  },

  created() {
    //  CKEDITOR.extraPlugins = 'font';
    // this.getAllTags();
    if (this.emailDataToken == undefined) {
      this.emailDataToken = Array();
    }

    this.modelStep.campaign_step_template_status_id = this.statusTemplate;
    this.model.language_id = this.lang;

    if (this.defaultTokens) {
      let keys = Object.keys(this.emailDataToken[0]);
      for (let i = 0; i < keys.length; i++) {
        if (
          this.emailDataToken[0][keys[i]] != undefined &&
          this.emailDataToken[0][keys[i]] != ""
        ) {
          this.testBusinessContact[0][keys[i]] =
            this.emailDataToken[0][keys[i]];
        }
      }
    }
    if (this.model.cantPerPage == undefined) {
      this.model.currentPage = 1;
      this.model.cantPerPage = this.cantPerPage;
    }
    //  if(this.modelCampaign.campaign_steps.length > 0 &&  campaignTemplate){
    //   this.templateList = this.modelCampaign.campaign_steps
    // }else{

    // }
    this.getData();
  },

  methods: {
    ...mapActions("header", {
      changeHeaderTab: "changeTab",
    }),
    formatTags() {
      this.modelStep.tags = this.tags.map(function (item) {
        return item.id;
      });
    },
    isRowSelected(template) {
      return (
        this.modelStep.id == template.id ||
        this.modelStep.parent_id == template.id
      );
    },
    getAllTags() {
      tagsService.getTags(2).then((tags) => {
        this.options = tags;
      });
    },
    getData() {
      this.loading = true;
      this.loadingCurrent = true;
      this.model.step = this.step;
      this.model.campaign_step_template_type_id =
        this.campaignStepTemplateTypeId;
      this.model.campaign_step_template_part_id =
        this.campaignStepTemplatePartId;
      this.model.isPreviewEmail = this.isPreviewEmail;
      this.model.tag_id = this.tag_id;
      this.model.enabled = this.enabled;

      if (this.currentPage == 1) {
        this.totalPages = 0;
      }
      adminService
        .getCampaignStepTemplates(this.model)
        .then((result) => {
          this.templateList = result.list;
          if (result.total != false) {
            this.totalItems = result.total;
          }
          if (this.templateList == undefined || this.templateList.length == 0) {
            this.newTemplate();
          }

          if (this.templateId) {
            if (
              this.templateList[this.templateId] !== undefined &&
              this.templateList[this.templateId].id !== undefined
            ) {
              this.getTemplate(this.templateList[this.templateId].id);
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    stepFormIsValid() {
      this.$refs.editorMessageV.validate();
      this.$refs.stepForm.validate();
      this.$refs.tagsV.validate();

      if (this.$refs.editorMessageV.errors == undefined) {
        this.$refs.editorMessageV.errors = [];
      }
      if (this.$refs.stepForm.errors == undefined) {
        this.$refs.stepForm.errors = [];
      }
      if (this.$refs.tagsV.errors == undefined) {
        this.$refs.tagsV.errors = [];
      }
      if (
        this.$refs.editorMessageV.errors.length == 0 &&
        this.$refs.stepForm.errors.length == 0 &&
        this.$refs.tagsV.errors.length == 0
      ) {
        return true;
      }
    },
    changePage() {
      if (
        this.model.currentPage < 1 ||
        (this.model.currentPage > 1 && this.model.currentPage > this.totalPages)
      ) {
        this.model.currentPage = 1;
      }
      this.selectFirst = true;
      this.getData();
    },

    getTemplate(id, is_parent) {
      this.loadingCurrent = true;
      if (is_parent === undefined) {
        this.modelStep = {};
        this.modelStep.id = id;
      }

      adminService
        .getCampaignStepTemplate(this.modelStep)
        .then((result) => {
          this.tags = [];
          if (result.id != undefined) {
            this.modelStep = result;
            if (this.modelStep.language_id != this.model.language_id) {
              // template for new language
              this.modelStep.language_id = this.model.language_id;
              this.modelStep.campaign_step_template_status_id = 1;
              this.modelStep.parent_id = this.modelStep.id;
              this.modelStep.id = null;
              this.modelStep.tags = result.tag;
            }

            if (result.tags !== undefined && result.tags.length > 0) {
              result.tags.forEach((tag) => {
                this.tags.push({
                  id: tag.id,
                  name: tag.name,
                  color: tag.color,
                });
              });
            }

            this.formatTags();
          }
        })
        .catch((err) => {
          this.$swal({
            type: "warning",
            title: this.$t("lang.label.error"),
            html: this.$t("lang.general.error"),
            showConfirmButton: true,
          });
        })
        .finally(() => {
          this.loadingCurrent = false;
        });
    },
    deleteStep() {
      if (this.enabled === "1") {
        this.$swal({
          type: "warning",
          title: "This notification is in use.",
          text: "Ask your administrator to disable it.",
          confirmButtonColor: "#3085d6",
          confirmButtonText: this.$t("lang.button.ok"),
        });
        return;
      }
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        text: this.$t("lang.label.areyousureyouwanttodeletethistemplate"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (!result.value) {
          return;
        }

        this.loadingCurrent = true;

        let id =
          this.modelStep.id === undefined
            ? this.modelStep.parent_id
            : this.modelStep.id;
        adminService
          .deleteCampaignStepTemplate(id)
          .then((result) => {
            this.totalItems--;
            this.getData();
            this.$swal({
              type: "success",
              title: this.$t("lang.label.great"),
              showConfirmButton: false,
              timer: 1500,
            });
            this.loadingCurrent = false;
          })
          .catch((err) => {
            this.$swal({
              type: "warning",
              title: this.$t("lang.label.error"),
              html: this.$t("lang.general.error"),
              showConfirmButton: true,
            });
            this.loadingCurrent = false;
          });
      });
    },
    saveStep() {
      if (!this.stepFormIsValid()) {
        this.$swal({
          type: "error",
          title: this.$t("lang.label.error"),
          text: this.$t("lang.label.checkdeerrormessagesintheformandtryagain"),
          showConfirmButton: true,
        });
        return;
      }
      this.loadingCurrent = true;
      this.modelStep.step = this.step;
      this.modelStep.campaign_step_template_type_id =
        this.campaignStepTemplateTypeId;
      this.modelStep.campaign_step_template_part_id =
        this.campaignStepTemplatePartId;

      adminService
        .setCampaignStepTemplate(this.modelStep)
        .then((result) => {
          if (
            this.modelStep.id == undefined &&
            this.modelStep.parent_id == undefined
          ) {
            this.totalItems++;
            this.model.currentPage = this.totalPages;
          }
          this.getTemplate(result);
          this.getData();
          this.$swal({
            type: "success",
            title: this.$t("lang.label.great"),
            showConfirmButton: false,
            timer: 1500,
          });
          this.loadingCurrent = false;
        })
        .catch((err) => {
          this.$swal({
            type: "warning",
            title: this.$t("lang.label.error"),
            html: this.$t("lang.general.error"),
            showConfirmButton: true,
          });
          this.loadingCurrent = false;
        });
    },
    newTemplate() {
      this.modelStep = { message: "" };
      this.modelStep.language_id = "1";
      this.modelStep.campaign_step_template_status_id = "1";
      this.modelStep.tag = [];
      this.tags = [];
    },
    // deleteAll() {
    //   this.$swal({
    //     type: "warning",
    //     title: this.$t("lang.label.areyousure"),
    //     text: this.$t("lang.label.areyousureyouwanttodeletethisNotification"),
    //     showCancelButton: true,
    //     confirmButtonColor: "#3085d6",
    //     cancelButtonColor: "#d33a2c",
    //     confirmButtonText: this.$t("lang.button.yes"),
    //     cancelButtonText: this.$t("lang.button.cancel"),
    //   }).then((result) => {
    //     if (!result.value) {
    //       return;
    //     }

    //     this.loadingCurrent = true;

    //     let id =
    //       this.modelStep.id === undefined
    //         ? this.modelStep.parent_id
    //         : this.modelStep.id;
    //     adminService
    //       .deleteCampaignStepTemplate(id)
    //       .then((result) => {
    //         this.totalItems--;
    //         this.getData();
    //         this.$swal({
    //           type: "success",
    //           title: this.$t("lang.label.great"),
    //           showConfirmButton: false,
    //           timer: 1500,
    //         });
    //         this.loadingCurrent = false;
    //       })
    //       .catch((err) => {
    //         this.$swal({
    //           type: "warning",
    //           title: this.$t("lang.label.error"),
    //           html: this.$t("lang.general.error"),
    //           showConfirmButton: true,
    //         });
    //         this.loadingCurrent = false;
    //       });
    //   });
    // },
  },
};
</script>

<style scoped>
.scroll-class {
  max-height: 600px;
  overflow-y: auto;
}
.datepicker {
  transform: translate(0, 3.1em);
}
</style>
